module.exports = __webpack_public_path__ + "static/media/nav-icon-managing-performance-inactive.ff63dd22.svg";